//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { Response } from '~/types/fetch'

export class AccountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    signUp(request: SignUpRequest, signal?: AbortSignal | undefined): Promise<SignUpVm> {
        let url_ = this.baseUrl + "/Account/sign-up";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<SignUpVm>(_response);
        });
    }

    signIn(request: SignInRequest, signal?: AbortSignal | undefined): Promise<SignInVm> {
        let url_ = this.baseUrl + "/Account/sign-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<SignInVm>(_response);
        });
    }

    verify(request: VerifyRequest, signal?: AbortSignal | undefined): Promise<VerifyResult> {
        let url_ = this.baseUrl + "/Account/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<VerifyResult>(_response);
        });
    }

    logOut(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Account/sign-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

    signUpSoft(request: SignUpRequest, signal?: AbortSignal | undefined): Promise<SignUpVm> {
        let url_ = this.baseUrl + "/Account/sign-up-soft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<SignUpVm>(_response);
        });
    }

    signInSoft(profileId: string, signal?: AbortSignal | undefined): Promise<SignInVm> {
        let url_ = this.baseUrl + "/Account/sign-in-soft/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<SignInVm>(_response);
        });
    }

    magicLink(request: VerifyMagicLinkRequest, signal?: AbortSignal | undefined): Promise<VerifyResult> {
        let url_ = this.baseUrl + "/Account/magic-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<VerifyResult>(_response);
        });
    }

    sendSaveLink(request: SendSaveLinkRequest, signal?: AbortSignal | undefined): Promise<SaveLinkResult> {
        let url_ = this.baseUrl + "/Account/send-save-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<SaveLinkResult>(_response);
        });
    }

}

export class ApplicationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getById(id: string, signal?: AbortSignal | undefined): Promise<Application> {
        let url_ = this.baseUrl + "/Applications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Application>(_response);
        });
    }

    createApplication(application: ApplicationCreate, signal?: AbortSignal | undefined): Promise<Application> {
        let url_ = this.baseUrl + "/Applications/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(application);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Application>(_response);
        });
    }

    saveApplication(application: ApplicationSave, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Applications/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(application);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

    submitApplication(application: ApplicationSubmitRequest, signal?: AbortSignal | undefined): Promise<ApplicationSubmitResponse> {
        let url_ = this.baseUrl + "/Applications/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(application);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<ApplicationSubmitResponse>(_response);
        });
    }

    cancelApplication(guid: string | undefined, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/Applications/cancel?";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

    addExt(applicationId: string, ext: ApplicationExt, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/Applications/{applicationId}/ext";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ext);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

}

export class AppSchemaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMapd(planType: PlanType | null | undefined, carrierKey: string | null | undefined, planYear: number | null | undefined, signal?: AbortSignal | undefined): Promise<AppSchemaResponse> {
        let url_ = this.baseUrl + "/AppSchema?";
        if (planType !== undefined && planType !== null)
            url_ += "PlanType=" + encodeURIComponent("" + planType) + "&";
        if (carrierKey !== undefined && carrierKey !== null)
            url_ += "CarrierKey=" + encodeURIComponent("" + carrierKey) + "&";
        if (planYear !== undefined && planYear !== null)
            url_ += "PlanYear=" + encodeURIComponent("" + planYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<AppSchemaResponse>(_response);
        });
    }

}

export class BeqClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    search(query: BeqSearchRequest, signal?: AbortSignal | undefined): Promise<SearchBenResponse> {
        let url_ = this.baseUrl + "/Beq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<SearchBenResponse>(_response);
        });
    }

}

export class CalendarClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    listUserEventTypes(user: string | null | undefined, organization: string | null | undefined, userAvailabilitySchedule: string | null | undefined, adminManaged: boolean | null | undefined, active: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<CalendlyPaginatedResponseOfEventType> {
        let url_ = this.baseUrl + "/Calendar/event-types?";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (organization !== undefined && organization !== null)
            url_ += "organization=" + encodeURIComponent("" + organization) + "&";
        if (userAvailabilitySchedule !== undefined && userAvailabilitySchedule !== null)
            url_ += "userAvailabilitySchedule=" + encodeURIComponent("" + userAvailabilitySchedule) + "&";
        if (adminManaged !== undefined && adminManaged !== null)
            url_ += "adminManaged=" + encodeURIComponent("" + adminManaged) + "&";
        if (active !== undefined && active !== null)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<CalendlyPaginatedResponseOfEventType>(_response);
        });
    }

    listEventTypeAvailableTypes(eventType: string | null | undefined, startTime: Date | undefined, endTime: Date | undefined, signal?: AbortSignal | undefined): Promise<CalendlyCollectionResponseOfEventTypeAvailableTime> {
        let url_ = this.baseUrl + "/Calendar/event-type/available-times?";
        if (eventType !== undefined && eventType !== null)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<CalendlyCollectionResponseOfEventTypeAvailableTime>(_response);
        });
    }

    getEvent(eventId: string, signal?: AbortSignal | undefined): Promise<CalendlyResourceResponseOfCalendlyEvent> {
        let url_ = this.baseUrl + "/Calendar/event/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<CalendlyResourceResponseOfCalendlyEvent>(_response);
        });
    }

    getEventInvitee(eventId: string, inviteeId: string, signal?: AbortSignal | undefined): Promise<CalendlyResourceResponseOfInvitee> {
        let url_ = this.baseUrl + "/Calendar/event/{eventId}/invitees/{inviteeId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        if (inviteeId === undefined || inviteeId === null)
            throw new Error("The parameter 'inviteeId' must be defined.");
        url_ = url_.replace("{inviteeId}", encodeURIComponent("" + inviteeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<CalendlyResourceResponseOfInvitee>(_response);
        });
    }

    listEventInvitees(eventId: string, email: string | null | undefined, signal?: AbortSignal | undefined): Promise<CalendlyPaginatedResponseOfInvitee> {
        let url_ = this.baseUrl + "/Calendar/events/{eventId}/invitees?";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<CalendlyPaginatedResponseOfInvitee>(_response);
        });
    }

}

export class ContactPhoneClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    saveContactPhone(contactPhone: ContactPhone, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/ContactPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contactPhone);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

}

export class CsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    sendMessage(message: CsMessageRequest, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

}

export class DrugsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    search(query: string | undefined, signal?: AbortSignal | undefined): Promise<DrugSearchResult[]> {
        let url_ = this.baseUrl + "/Drugs/search?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<DrugSearchResult[]>(_response);
        });
    }

    autocomplete(query: string | undefined, skip: number | undefined, take: number | undefined, signal?: AbortSignal | undefined): Promise<DrugAutocompleteResult[]> {
        let url_ = this.baseUrl + "/Drugs/autocomplete?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<DrugAutocompleteResult[]>(_response);
        });
    }

    get(externalId: string, signal?: AbortSignal | undefined): Promise<DrugData> {
        let url_ = this.baseUrl + "/Drugs/{externalId}";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<DrugData>(_response);
        });
    }

    findByNdc(ndc: string, signal?: AbortSignal | undefined): Promise<DrugData> {
        let url_ = this.baseUrl + "/Drugs/ndc/{ndc}";
        if (ndc === undefined || ndc === null)
            throw new Error("The parameter 'ndc' must be defined.");
        url_ = url_.replace("{ndc}", encodeURIComponent("" + ndc));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<DrugData>(_response);
        });
    }

    searchCacheExact(query: string | undefined, signal?: AbortSignal | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Drugs/cache/search-exact?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<string[]>(_response);
        });
    }

    searchCacheFuzzy(query: string | undefined, signal?: AbortSignal | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Drugs/cache/search-fuzzy?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<string[]>(_response);
        });
    }

}

export class GeoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCounties(zipCode: string, signal?: AbortSignal | undefined): Promise<CountyData[]> {
        let url_ = this.baseUrl + "/Geo/counties/{zipCode}";
        if (zipCode === undefined || zipCode === null)
            throw new Error("The parameter 'zipCode' must be defined.");
        url_ = url_.replace("{zipCode}", encodeURIComponent("" + zipCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<CountyData[]>(_response);
        });
    }

    cityAutocomplete(query: string | undefined, sessionToken: string | null | undefined, signal?: AbortSignal | undefined): Promise<GooglePlacesCityPrediction[]> {
        let url_ = this.baseUrl + "/Geo/autocomplete/cities?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (sessionToken !== undefined && sessionToken !== null)
            url_ += "sessionToken=" + encodeURIComponent("" + sessionToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<GooglePlacesCityPrediction[]>(_response);
        });
    }

    addressAutocomplete(query: string | undefined, lat: number | null | undefined, lng: number | null | undefined, radius: number | null | undefined, sessionToken: string | null | undefined, signal?: AbortSignal | undefined): Promise<GooglePlacesAddressPrediction[]> {
        let url_ = this.baseUrl + "/Geo/autocomplete/address?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (lat !== undefined && lat !== null)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lng !== undefined && lng !== null)
            url_ += "lng=" + encodeURIComponent("" + lng) + "&";
        if (radius !== undefined && radius !== null)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        if (sessionToken !== undefined && sessionToken !== null)
            url_ += "sessionToken=" + encodeURIComponent("" + sessionToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<GooglePlacesAddressPrediction[]>(_response);
        });
    }

    getPlaceDetails(placeId: string | undefined, fields: string[] | undefined, sessionToken: string | null | undefined, includeTimeZone: boolean | undefined, signal?: AbortSignal | undefined): Promise<GooglePlacesDetails> {
        let url_ = this.baseUrl + "/Geo/place/details?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            fields && fields.forEach(item => { url_ += "fields=" + encodeURIComponent("" + item) + "&"; });
        if (sessionToken !== undefined && sessionToken !== null)
            url_ += "sessionToken=" + encodeURIComponent("" + sessionToken) + "&";
        if (includeTimeZone === null)
            throw new Error("The parameter 'includeTimeZone' cannot be null.");
        else if (includeTimeZone !== undefined)
            url_ += "includeTimeZone=" + encodeURIComponent("" + includeTimeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<GooglePlacesDetails>(_response);
        });
    }

    geocodeZipcode(zipcode: string, signal?: AbortSignal | undefined): Promise<ZipCoordinates> {
        let url_ = this.baseUrl + "/Geo/geocode/zip/{zipcode}";
        if (zipcode === undefined || zipcode === null)
            throw new Error("The parameter 'zipcode' must be defined.");
        url_ = url_.replace("{zipcode}", encodeURIComponent("" + zipcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<ZipCoordinates>(_response);
        });
    }

}

export class OutboundContactClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    saveCallRequest(data: OutboundContactRequestData, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/OutboundContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

}

export class PharmacyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    search(request: PharmacySearchRequest, signal?: AbortSignal | undefined): Promise<PharmacySearchResult[]> {
        let url_ = this.baseUrl + "/Pharmacy/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<PharmacySearchResult[]>(_response);
        });
    }

    findByNpi(npi: string, signal?: AbortSignal | undefined): Promise<PharmacySearchResult> {
        let url_ = this.baseUrl + "/Pharmacy/npi/{npi}";
        if (npi === undefined || npi === null)
            throw new Error("The parameter 'npi' must be defined.");
        url_ = url_.replace("{npi}", encodeURIComponent("" + npi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<PharmacySearchResult>(_response);
        });
    }

}

export class PlanCheckupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createPlanCheckup(planYear: number | undefined, currentPlanId: string | null | undefined, currentPlanType: PlanType | null | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/PlanCheckup?";
        if (planYear === null)
            throw new Error("The parameter 'planYear' cannot be null.");
        else if (planYear !== undefined)
            url_ += "planYear=" + encodeURIComponent("" + planYear) + "&";
        if (currentPlanId !== undefined && currentPlanId !== null)
            url_ += "currentPlanId=" + encodeURIComponent("" + currentPlanId) + "&";
        if (currentPlanType !== undefined && currentPlanType !== null)
            url_ += "currentPlanType=" + encodeURIComponent("" + currentPlanType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<string>(_response);
        });
    }

    updatePlanCheckup(checkupId: string, checkup: PlanCheckup, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/PlanCheckup/{checkupId}";
        if (checkupId === undefined || checkupId === null)
            throw new Error("The parameter 'checkupId' must be defined.");
        url_ = url_.replace("{checkupId}", encodeURIComponent("" + checkupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkup);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

}

export class ProfilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(signal?: AbortSignal | undefined): Promise<Profile> {
        let url_ = this.baseUrl + "/Profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Profile>(_response);
        });
    }

    create(profile: Profile | undefined, signal?: AbortSignal | undefined): Promise<Profile> {
        let url_ = this.baseUrl + "/Profiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Profile>(_response);
        });
    }

    update(profile: ProfileBase, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/Profiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profile);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

    setEngineId(engineId: BoxOfString, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/Profiles/engine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(engineId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

    savePharmacy(pharmacy: Pharmacy, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Profiles/pharmacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pharmacy);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<string>(_response);
        });
    }

    deletePharmacy(externalId: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Profiles/pharmacy/{externalId}";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

    updatePreferredPharmacy(externalId: string, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/Profiles/pharmacy/{externalId}/preferred";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

    saveProvider(provider: Provider, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Profiles/providers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(provider);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<string>(_response);
        });
    }

    deleteProvider(npi: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Profiles/provider/{npi}";
        if (npi === undefined || npi === null)
            throw new Error("The parameter 'npi' must be defined.");
        url_ = url_.replace("{npi}", encodeURIComponent("" + npi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

    saveRx(previousNdc: string | null | undefined, rx: Rx, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Profiles/rxs?";
        if (previousNdc !== undefined && previousNdc !== null)
            url_ += "previousNdc=" + encodeURIComponent("" + previousNdc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rx);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<string>(_response);
        });
    }

    deleteRx(externalId: string, ndc: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Profiles/rxs/{externalId}/{ndc}";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        if (ndc === undefined || ndc === null)
            throw new Error("The parameter 'ndc' must be defined.");
        url_ = url_.replace("{ndc}", encodeURIComponent("" + ndc));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

    updateSavedPlans(savedPlans: { [key: string]: string[]; }, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/Profiles/savedPlans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(savedPlans);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

    getPlanTypeRecommendations(request: PlanTypeRecommendationRequest, signal?: AbortSignal | undefined): Promise<PlanTypeRecommendation> {
        let url_ = this.baseUrl + "/Profiles/recommendations/plan-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<PlanTypeRecommendation>(_response);
        });
    }

    testPlanTypeRecommendations(config: PlanTypeRecommendationConfig, signal?: AbortSignal | undefined): Promise<PlanTypeRecommendation> {
        let url_ = this.baseUrl + "/Profiles/recommendations/plan-type/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<PlanTypeRecommendation>(_response);
        });
    }

    getEligibility(partADate: Date | null | undefined, partBDate: Date | null | undefined, birthdate: Date | undefined, planType: PlanType | undefined, planYear: number | undefined, signal?: AbortSignal | undefined): Promise<EligibilityResponse> {
        let url_ = this.baseUrl + "/Profiles/eligibility?";
        if (partADate !== undefined && partADate !== null)
            url_ += "partADate=" + encodeURIComponent(partADate ? "" + partADate.toISOString() : "") + "&";
        if (partBDate !== undefined && partBDate !== null)
            url_ += "partBDate=" + encodeURIComponent(partBDate ? "" + partBDate.toISOString() : "") + "&";
        if (birthdate === null)
            throw new Error("The parameter 'birthdate' cannot be null.");
        else if (birthdate !== undefined)
            url_ += "birthdate=" + encodeURIComponent(birthdate ? "" + birthdate.toISOString() : "") + "&";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        if (planYear === null)
            throw new Error("The parameter 'planYear' cannot be null.");
        else if (planYear !== undefined)
            url_ += "planYear=" + encodeURIComponent("" + planYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<EligibilityResponse>(_response);
        });
    }

    getIepRecommendation(request: IepRecommendationRequest, signal?: AbortSignal | undefined): Promise<IepRecommendationResponse> {
        let url_ = this.baseUrl + "/Profiles/iep-recommendation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<IepRecommendationResponse>(_response);
        });
    }

    updateIepContext(iepContext: { [key: string]: any; }, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/Profiles/iep-context";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iepContext);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

    addDataConsent(consent: DataConsent, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Profiles/data/consent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

    createTestimonial(testimonial: Testimonial, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Profiles/testimonials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testimonial);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<string>(_response);
        });
    }

    updateTestimonial(testimonialId: string, responses: any, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Profiles/testimonials/{testimonialId}";
        if (testimonialId === undefined || testimonialId === null)
            throw new Error("The parameter 'testimonialId' must be defined.");
        url_ = url_.replace("{testimonialId}", encodeURIComponent("" + testimonialId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(responses);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

    saveScheduledCall(call: ScheduleCallRequest, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Profiles/calls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(call);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<string>(_response);
        });
    }

    addExt(ext: ProfileExt, signal?: AbortSignal | undefined): Promise<Unit> {
        let url_ = this.baseUrl + "/Profiles/ext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ext);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Unit>(_response);
        });
    }

}

export class ProvidersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    autocomplete(request: ProviderSearchRequest, signal?: AbortSignal | undefined): Promise<ProviderSearchResult[]> {
        let url_ = this.baseUrl + "/Providers/autocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<ProviderSearchResult[]>(_response);
        });
    }

    findByNpis(npis: string[] | undefined, signal?: AbortSignal | undefined): Promise<ProviderSearchResult[]> {
        let url_ = this.baseUrl + "/Providers/npis?";
        if (npis === null)
            throw new Error("The parameter 'npis' cannot be null.");
        else if (npis !== undefined)
            npis && npis.forEach(item => { url_ += "npis=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<ProviderSearchResult[]>(_response);
        });
    }

    findByNpi(npi: string, signal?: AbortSignal | undefined): Promise<ProviderSearchResult> {
        let url_ = this.baseUrl + "/Providers/npi/{npi}";
        if (npi === undefined || npi === null)
            throw new Error("The parameter 'npi' must be defined.");
        url_ = url_.replace("{npi}", encodeURIComponent("" + npi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<ProviderSearchResult>(_response);
        });
    }

}

export class SessionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(signal?: AbortSignal | undefined): Promise<SessionVm> {
        let url_ = this.baseUrl + "/Session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<SessionVm>(_response);
        });
    }

    save(data: any | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

    end(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<void>(_response);
        });
    }

}

export class SiteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getJourney(id: number, signal?: AbortSignal | undefined): Promise<Journey> {
        let url_ = this.baseUrl + "/Site/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Journey>(_response);
        });
    }

    allJourneys(signal?: AbortSignal | undefined): Promise<Journey[]> {
        let url_ = this.baseUrl + "/Site";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<Journey[]>(_response);
        });
    }

    bootstrapFlags(userKey: string | undefined, isAnon: boolean | undefined, signal?: AbortSignal | undefined): Promise<BootstrapFlagState> {
        let url_ = this.baseUrl + "/Site/bootstrap/flags?";
        if (userKey === null)
            throw new Error("The parameter 'userKey' cannot be null.");
        else if (userKey !== undefined)
            url_ += "userKey=" + encodeURIComponent("" + userKey) + "&";
        if (isAnon === null)
            throw new Error("The parameter 'isAnon' cannot be null.");
        else if (isAnon !== undefined)
            url_ += "isAnon=" + encodeURIComponent("" + isAnon) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<BootstrapFlagState>(_response);
        });
    }

}

export class WwwClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    bootstrapFlags(userKey: string | undefined, isAnon: boolean | undefined, signal?: AbortSignal | undefined): Promise<BootstrapFlagState> {
        let url_ = this.baseUrl + "/Www/bootstrap/flags?";
        if (userKey === null)
            throw new Error("The parameter 'userKey' cannot be null.");
        else if (userKey !== undefined)
            url_ += "userKey=" + encodeURIComponent("" + userKey) + "&";
        if (isAnon === null)
            throw new Error("The parameter 'isAnon' cannot be null.");
        else if (isAnon !== undefined)
            url_ += "isAnon=" + encodeURIComponent("" + isAnon) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<BootstrapFlagState>(_response);
        });
    }

}

export class EnrollmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    start(request: EnrollRequest, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/enrollments/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<FileResponse>(_response);
        });
    }

    retrieveToken(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/enrollments/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<FileResponse>(_response);
        });
    }

    retrieveSession(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/enrollments/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<FileResponse>(_response);
        });
    }

}

export class QuotingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    footprint(request: CarrierFootprintRequest, signal?: AbortSignal | undefined): Promise<CarrierFootprint[]> {
        let url_ = this.baseUrl + "/Quoting/plans/footprint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<CarrierFootprint[]>(_response);
        });
    }

    medigapFootprint(ps: MedigapFootprintParams, signal?: AbortSignal | undefined): Promise<MedigapFootprintResponse> {
        let url_ = this.baseUrl + "/Quoting/plans/footprint/ms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ps);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<MedigapFootprintResponse>(_response);
        });
    }

    runEngine(request: RunEngineRequest, signal?: AbortSignal | undefined): Promise<EngineSnapshot> {
        let url_ = this.baseUrl + "/Quoting/engine/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<EngineSnapshot>(_response);
        });
    }

    getEngine(id: string, signal?: AbortSignal | undefined): Promise<EngineSnapshot> {
        let url_ = this.baseUrl + "/Quoting/engine/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<EngineSnapshot>(_response);
        });
    }

    refreshPlanCarrierMap(request: BoxOfString, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Quoting/refresh-mapped-plans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<FileResponse>(_response);
        });
    }

}

export class RedirectClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    start(request: EnrollRequest, signal?: AbortSignal | undefined): Promise<EnrollResponse> {
        let url_ = this.baseUrl + "/Redirect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return processResponse<EnrollResponse>(_response);
        });
    }

}

export interface SignUpVm {
    result?: SignUpResult;
    token?: string | null;
}

export enum SignUpResult {
    Success = 0,
    Error = 1,
    AlreadyExists = 2,
}

export interface SignUpRequest {
    identifier?: string;
    profileId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthDate?: string | null;
    registrationToken?: string | null;
    mergeIfExisting?: boolean;
    analyticsData?: { [key: string]: any; } | null;
}

export interface SignInVm {
    result?: SignInResult;
    showTcpaConsent?: boolean | null;
}

export enum SignInResult {
    CodeSent = 0,
    Error = 1,
    DoesNotExist = 2,
    Soft = 3,
}

export interface SignInRequest {
    identifier?: string;
}

export enum VerifyResult {
    Success = 0,
    Error = 1,
    InvalidPasscode = 2,
}

export interface VerifyRequest {
    identifier?: string;
    code?: string;
    registrationToken?: string | null;
    profileId?: string | null;
    attribution?: Attribution | null;
    analyticsData?: { [key: string]: any; } | null;
}

export interface Attribution {
    createdAt?: Date | null;
    params?: { [key: string]: string; };
}

export interface VerifyMagicLinkRequest {
    code?: string;
    profileId?: string | null;
}

export enum SaveLinkResult {
    Success = 1,
    Error = 2,
}

export interface SendSaveLinkRequest {
    email?: string;
    applicationId?: string;
    profileId?: string | null;
    medicareId?: string | null;
    planName?: string | null;
    planYear?: number | null;
    planType?: PlanType | null;
    carrierLogo?: string | null;
}

export enum PlanType {
    MA = 1,
    PDP = 2,
    MAPD = 3,
    GAP = 4,
    MSA = 5,
    TM = 999,
}

export interface Application {
    id?: string | null;
    profileId?: string | null;
    status?: string;
    planName?: string;
    planLetter?: string | null;
    planYear?: number;
    medicareId?: string;
    planExternalId?: string | null;
    carrierId?: string;
    carrierKey?: string;
    carrierName?: string;
    brandName?: string;
    naic?: string | null;
    brandId?: string;
    flow?: ApplicationFlow;
    destination?: ApplicationDestination;
    requestedEffectiveDate?: Date | null;
    submittedTimestamp?: Date | null;
    updatedAt?: Date | null;
    timeZoneId?: string | null;
    utcOffset?: number | null;
    planType?: PlanType;
    currentPageId?: string | null;
    enrollmentCode?: string | null;
    rawEngineData?: string | null;
    logoKey?: string;
    monthlyPremium?: number | null;
    sobUrl?: string | null;
    eocUrl?: string | null;
    snpType?: SnpType | null;
    engineData?: { [key: string]: any; };
    rawJson?: string | null;
    answers?: { [key: string]: any; };
    ext?: ApplicationExt[];
}

export enum ApplicationFlow {
    AppSchema = 1,
    ConnectureRedirect = 2,
    AppSchemaMs = 3,
    ConnectureRedirectMs = 4,
    CarrierRedirectMs = 5,
    MsT = 6,
    Legacy = 999,
}

export enum ApplicationDestination {
    OnRamp = 1,
    ConnectureWebhook = 2,
    AgentEntry = 3,
    External = 4,
    MsT = 5,
    Legacy = 999,
}

export enum SnpType {
    DualEligible = 1,
    LongTermCare = 2,
    ChronicCare = 3,
    None = -1,
}

export interface ApplicationExt {
    key?: string;
    valueType?: string | null;
    value?: string | null;
    createdAt?: Date;
}

export interface ApplicationCreate {
    profileId?: string;
    planYear?: number;
    medicareId?: string;
    carrierId?: string;
    carrierKey?: string;
    carrierName?: string;
    brandName?: string;
    brandId?: string;
    engineData?: { [key: string]: any; };
    planName?: string;
    planLetter?: string | null;
    planExternalId?: string | null;
    naic?: string | null;
    planType?: PlanType;
    policyType?: PolicyType;
    flow?: ApplicationFlow;
    destination?: ApplicationDestination;
    logoKey?: string;
    monthlyPremium?: number | null;
    sobUrl?: string | null;
    eocUrl?: string | null;
    snpType?: SnpType | null;
    ext?: ApplicationExt[];
}

export enum PolicyType {
    None = 0,
    Demo = 1,
    HMO = 2,
    HMOPOS = 3,
    LPPO = 4,
    MSA = 5,
    PFFS = 6,
    PPO = 7,
    RPPO = 8,
    CCOTH = 9,
    Cost = 10,
    ESRD1 = 11,
    ESRD2 = 12,
    MA_HSCO = 13,
    MN_DHO = 14,
    MN_SHO = 15,
    Original_Medicare = 16,
    PSO_Federal_Waiver = 17,
    PSO_State_License = 18,
    SHMO = 19,
    WI_PP = 20,
    DSNP = 100,
    CSNP = 101,
    LSNP = 102,
}

export interface ApplicationSave {
    applicationId?: string;
    answers?: { [key: string]: any; };
    currentPageId?: string | null;
}

export interface ApplicationSubmitResponse {
    confirmationCode?: string;
}

export interface ApplicationSubmitRequest {
    applicationId?: string;
    requestedEffectiveDate?: Date | null;
    timeZoneId?: string | null;
    utcOffset?: number | null;
}

export interface Unit {
}

export interface AppSchemaResponse {
    schema?: AppSchemaVm;
    layout?: AppLayoutVm;
}

export interface AppSchemaVm {
    id?: string;
    planType?: PlanType;
    carrierKey?: string;
    planYear?: number;
    sections?: AppSchemaSectionVm[];
    modals?: AppSchemaModalVm[];
    enableBeq?: boolean;
}

export interface AppSchemaSectionVm {
    sectionId?: string;
    header?: string | null;
    subHeader?: string | null;
    modalId?: string | null;
    linkText?: string | null;
    reviewable?: boolean;
    renderAsHtml?: string[];
    dependencies?: AppSchemaFieldDependenciesVm;
    fields?: AppSchemaFieldVm[];
}

export interface AppSchemaFieldDependenciesVm {
    rules?: AppSchemaRuleVm[];
    isPeer?: boolean;
    visibilityOperator?: AppSchemaRuleOperators;
    requiredOperator?: AppSchemaRuleOperators;
}

export interface AppSchemaRuleVm {
    ruleType?: AppSchemaRuleTypes;
    fieldId?: string;
    condition?: AppSchemaConditionTypes;
    conditionValue?: any;
}

export enum AppSchemaRuleTypes {
    ShowIf = 1,
    EnableIf = 2,
    DisableIf = 3,
    RequireIf = 4,
}

export enum AppSchemaConditionTypes {
    MustEqual = 1,
    MustNotEqual = 2,
    MustInclude = 3,
    MustNotInclude = 4,
    MustHaveValue = 5,
    MustNotHaveValue = 6,
}

export enum AppSchemaRuleOperators {
    And = 0,
    Or = 1,
}

export interface AppSchemaFieldVm {
    fieldId?: string | null;
    fieldType?: string;
    fieldName?: string | null;
    label?: string | null;
    content?: any;
    min?: number | null;
    max?: number | null;
    defaultValue?: any | null;
    isReadOnly?: boolean;
    placeholder?: string | null;
    helpText?: string | null;
    secure?: boolean;
    uppercase?: boolean;
    showTopNOptions?: number | null;
    modalId?: string | null;
    linkText?: string | null;
    exclusiveOption?: string | null;
    customMessages?: { [key: string]: string; };
    options?: AppSchemaOptionVm[];
    validations?: { [key: string]: any; };
    dependencies?: AppSchemaFieldDependenciesVm;
    includeInField?: AppSchemaIncludeInFieldVm | null;
    children?: AppSchemaFieldVm[];
}

export interface AppSchemaOptionVm {
    value?: any;
    text?: string;
    modalId?: string | null;
    modalText?: string | null;
    clientValidator?: string | null;
}

export interface AppSchemaIncludeInFieldVm {
    fieldId?: string;
    value?: any;
}

export interface AppSchemaModalVm {
    modalId?: string;
    modalTitle?: string;
    modalText?: string;
    isSideBar?: boolean;
}

export interface AppLayoutVm {
    sections?: AppLayoutSectionVm[];
    pages?: AppLayoutPageVm[];
    steps?: AppLayoutStepVm[];
    id?: string;
    schemaId?: string;
    totalColumns?: number;
}

export interface AppLayoutSectionVm {
    sectionId?: string;
    columns?: AppLayoutColumnVm[];
    groups?: FieldGroupVm[];
}

export interface AppLayoutColumnVm {
    fieldId?: string;
    desktopWidth?: number;
    mobileWidth?: number;
    height?: number | null;
    layout?: AppLayoutColumnVm[] | null;
}

export interface FieldGroupVm {
    id?: string;
    title?: string | null;
    fields?: string[];
    type?: string;
    indicator?: string | null;
}

export interface AppLayoutPageVm {
    pageId?: string;
    title?: string;
    modalId?: string;
    linkText?: string;
    sections?: string[];
    stepId?: string;
}

export interface AppLayoutStepVm {
    stepId?: string;
    title?: string;
}

export interface SearchBenResponse {
    beneficiaryInformation?: BeqBeneficiary;
    caraPeriods?: BeqPeriod[];
    currentEnrollmentPeriods?: BeqEnrollment[];
    entitlementReason?: BeqEntitlementReason[];
    esrdCoverage?: BeqEsrPeriod[];
    hasMedicaid?: boolean;
    hospicePeriods?: BeqPeriod[];
    inactiveMbi?: BeqMedicareBeneficiaryIdentifier[];
    incarcerationPeriods?: BeqPeriod[];
    institutionalPeriods?: BeqPeriod[];
    latestSpecialEnrollmentPeriodUseDate?: Date;
    lowIncomeSubsidyPeriods?: BeqLowIncomeSubsidy[];
    mailingAddress?: BeqAddress;
    medicaidPeriods?: BeqPeriod[];
    medicareCardRequest?: BeqMedicareCardRequest[];
    medicareStatus?: string;
    notLawfulPresencePeriods?: BeqPeriod[];
    partAEntitlementPeriods?: BeqPeriod[];
    partBEntitlementPeriods?: BeqPeriod[];
    partDEligibilityPeriods?: BeqPeriod[];
    partDEnrollmentPeriods?: BeqPeriod[];
    priorEnrollmentPeriods?: BeqEnrollment[];
    residenceAddress?: BeqAddress[];
    retireeDrugCoverage?: BeqPeriod[];
    stateCounty?: BeqStateCounty[];
    uncoveredMonths?: BeqUncoveredMonths[];
}

export interface BeqBeneficiary {
    beneficiaryKey?: number;
    birthDate?: Date;
    deathDate?: Date | null;
    deathDateProof?: string;
    firstName?: string;
    gender?: string;
    lastName?: string;
    medicareBeneficiaryIdentifier?: string;
    middleInitial?: string;
    race?: string;
}

export interface BeqPeriod {
    startDate?: Date;
    stopDate?: Date | null;
}

export interface BeqEnrollment {
    addedDateTime?: Date;
    contractNumber?: string;
    disenrollmentDate?: Date | null;
    enrollmentDate?: Date;
    isEmployerGroupHealthPlan?: boolean;
    planBenefitPackageNumber?: string;
    planType?: string;
    programType?: string;
    segmentNumber?: string;
    sourceType?: string;
}

export interface BeqEntitlementReason {
    entitlementReason?: string;
    entitlementReasonChangeDate?: Date | null;
}

export interface BeqEsrPeriod {
    esrdIndicator?: string;
    startDate?: Date;
    stopDate?: Date | null;
}

export interface BeqMedicareBeneficiaryIdentifier {
    effectiveDate?: Date;
    medicareBeneficiaryIdentifier?: string;
    terminationDate?: Date;
}

export interface BeqLowIncomeSubsidy {
    copaymentLevel?: number;
    isDeemed?: boolean;
    premiumSubsidyPercent?: number;
    startDate?: Date;
    stopDate?: Date | null;
}

export interface BeqAddress {
    addressLines?: string[];
    addressStartDate?: Date;
    city?: string;
    postalStateCode?: string;
    zipCode?: string;
}

export interface BeqMedicareCardRequest {
    cardRequestDate?: Date;
    medicareBeneficiaryIdentifier?: string;
}

export interface BeqStateCounty {
    fipsCounty?: string;
    fipsState?: string;
    ssaCounty?: string;
    ssaState?: string;
    zipCode?: string;
}

export interface BeqUncoveredMonths {
    monthsCount?: number;
    startDate?: Date;
    status?: string;
}

export interface BeqSearchRequest {
    agentSan?: string | null;
    beneficiary?: Beneficiary;
    contractNumber?: string;
    coverageEffectiveDate?: Date | null;
    transactionId?: string | null;
}

export interface Beneficiary {
    dob?: Date;
    gender?: string | null;
    id?: string;
}

export interface CalendlyCollectionResponseOfEventType {
    collection?: EventType[];
}

export interface CalendlyPaginatedResponseOfEventType extends CalendlyCollectionResponseOfEventType {
    pagination?: PaginationResult;
}

export function isCalendlyPaginatedResponseOfEventType(object: any): object is CalendlyPaginatedResponseOfEventType {
    return object && object[''] === 'CalendlyPaginatedResponseOfEventType';
}

export interface PaginationResult {
    count?: number;
    nextPage?: string | null;
    previousPage?: string | null;
    nextPageToken?: string | null;
    previousPageToken?: string | null;
}

export interface EventType {
    uri?: string;
    name?: string | null;
    active?: boolean;
    slug?: string | null;
    schedulingUri?: string;
    duration?: number;
    durationOptions?: number[] | null;
    kind?: string;
    poolingType?: string | null;
    type?: string;
    color?: string;
    createdAt?: Date;
    updatedAt?: Date;
    internalNote?: string | null;
    descriptionPlain?: string | null;
    descriptionHtml?: string | null;
    profile?: CalendlyProfile;
    secret?: boolean;
    bookingMethod?: string;
    customQuestions?: EventTypeCustomQuestion[];
    deletedAt?: Date | null;
    adminManaged?: boolean;
    locations?: any[];
    position?: number;
}

export interface CalendlyProfile {
    type?: string;
    name?: string;
    owner?: string;
}

export interface EventTypeCustomQuestion {
    name?: string;
    type?: string;
    position?: number;
    enabled?: boolean;
    required?: boolean;
    answerChoices?: string[];
    includeOther?: boolean;
}

export interface CalendlyCollectionResponseOfEventTypeAvailableTime {
    collection?: EventTypeAvailableTime[];
}

export interface EventTypeAvailableTime {
    status?: string;
    inviteesRemaining?: number;
    startTime?: Date;
    schedulingUrl?: string;
}

export interface CalendlyResourceResponseOfCalendlyEvent {
    resource?: CalendlyEvent | null;
}

export interface CalendlyEvent {
    uri?: string;
    name?: string;
    meetingNotesPlain?: string | null;
    meetingNotesHtml?: string | null;
    status?: string;
    startTime?: Date;
    endTime?: Date;
    eventType?: string;
    location?: any;
    inviteesCounter?: InviteesCounter;
    createdAt?: Date;
    updatedAt?: Date;
    eventMemberships?: EventMemberships[];
    eventGuests?: Guest[];
    cancellation?: Cancellation;
}

export interface InviteesCounter {
    total?: number;
    active?: number;
    limit?: number;
}

export interface EventMemberships {
    user?: string;
    userEmail?: string | null;
    userName?: string | null;
    bufferedEndTime?: Date;
    bufferedStartTime?: Date;
}

export interface Guest {
    email?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface Cancellation {
    canceledBy?: string;
    reason?: string;
    cancelerType?: string;
    createdAt?: Date;
}

export interface CalendlyResourceResponseOfInvitee {
    resource?: Invitee | null;
}

export interface Invitee {
    uri?: string;
    email?: string;
    firstName?: string | null;
    lastName?: string | null;
    name?: string;
    status?: string;
    questionsAndAnswers?: InviteeQuestionAnswer[];
    timezone?: string | null;
    event?: string;
    createdAt?: Date;
    updatedAt?: Date;
    tracking?: InviteeTracking;
    textReminderNumber?: string | null;
    rescheduled?: boolean;
    oldInvitee?: string | null;
    newInvitee?: string | null;
    cancelUrl?: string;
    rescheduleUrl?: string;
    routingFormSubmission?: string | null;
    cancellation?: Cancellation | null;
    payment?: Payment | null;
    noShow?: InviteeNoShow | null;
    reconfirmation?: InviteeReconfirmation | null;
    schedulingMethod?: string | null;
    inviteeScheduledBy?: string | null;
}

export interface InviteeQuestionAnswer {
    question?: string;
    answer?: string;
    position?: number;
}

export interface InviteeTracking {
    utmCampaign?: string | null;
    utmSource?: string | null;
    utmMedium?: string | null;
    utmContent?: string | null;
    utmTerm?: string | null;
    salesforceUuid?: string | null;
}

export interface Payment {
    externalId?: string;
    provider?: string;
    amount?: number;
    currency?: string;
    terms?: string | null;
    successful?: boolean;
}

export interface InviteeNoShow {
    uri?: string;
    invitee?: string;
    createdAt?: Date;
}

export interface InviteeReconfirmation {
    createdAt?: Date;
    confirmedAt?: Date | null;
}

export interface CalendlyCollectionResponseOfInvitee {
    collection?: Invitee[];
}

export interface CalendlyPaginatedResponseOfInvitee extends CalendlyCollectionResponseOfInvitee {
    pagination?: PaginationResult;
}

export function isCalendlyPaginatedResponseOfInvitee(object: any): object is CalendlyPaginatedResponseOfInvitee {
    return object && object[''] === 'CalendlyPaginatedResponseOfInvitee';
}

export interface ContactPhone {
    id?: string;
    profileId?: string;
    number?: string;
    type?: string;
    isMobileVerified?: boolean;
}

export interface CsMessageRequest {
    event?: string;
    attributes?: CsMessageAttributes;
}

export interface CsMessageAttributes {
    profileId?: string;
    source?: string;
    planType?: string;
    customerName?: string;
    customerPhone?: string;
    customerEmail?: string;
    userMessage?: string;
    description?: string;
    viewedPlans?: string;
}

export interface DrugSearchResult {
    externalId?: string;
    drugName?: string;
    chemicalName?: string;
    ndc?: string;
    drugType?: DrugType;
    isGeneric?: boolean;
    genericExternalId?: string | null;
    genericDrugName?: string | null;
}

export enum DrugType {
    Brand = 1,
    Generic = 2,
    OtcBrand = 3,
    BrandedGeneric = 4,
    OtcBrandedGeneric = 5,
    OtcGeneric = 6,
}

export interface DrugAutocompleteResult {
    externalId?: string;
    drugName?: string;
    isGeneric?: boolean;
}

export interface DrugData {
    externalId?: string;
    drugName?: string;
    chemicalName?: string | null;
    drugType?: DrugType;
    isGeneric?: boolean;
    genericExternalId?: string | null;
    genericDrugName?: string | null;
    genericDrugType?: DrugType | null;
    genericDosages?: DosageData[];
    dosages?: DosageData[];
}

export interface DosageData {
    externalId?: string;
    ndc?: string | null;
    labelName?: string;
    strength?: string;
    commonQuantity?: number;
    commonMetricQuantity?: number;
    commonFrequency?: number;
    form?: string;
    formName?: string;
    isCommonDosage?: boolean | null;
    packages?: PackageData[];
}

export interface PackageData {
    ndc?: string;
    displayText?: string;
    description?: string;
    unitOfMeasure?: string;
    packageSize?: number;
    packageQuantity?: number;
    totalPackageQuantity?: number | null;
    commonQuantity?: number | null;
    commonMetricQuantity?: number | null;
    isCommonPackage?: boolean | null;
}

export interface CountyData {
    zipCode?: string;
    fipsCountyCode?: string;
    countyName?: string;
    stateCode?: string;
    stateName?: string;
}

export interface GooglePlacesAutocompletePrediction {
    description?: string;
    placeId?: string;
    terms?: PredictionTerm[];
}

export interface GooglePlacesCityPrediction extends GooglePlacesAutocompletePrediction {
    city?: string;
    state?: string;
    country?: string;
    termsNoCountry?: string[] | null;
    displayName?: string;
}

export function isGooglePlacesCityPrediction(object: any): object is GooglePlacesCityPrediction {
    return object && object[''] === 'GooglePlacesCityPrediction';
}

export interface PredictionTerm {
    offset?: number;
    value?: string;
}

export interface GooglePlacesAddressPrediction extends GooglePlacesAutocompletePrediction {
}

export function isGooglePlacesAddressPrediction(object: any): object is GooglePlacesAddressPrediction {
    return object && object[''] === 'GooglePlacesAddressPrediction';
}

export interface GooglePlacesDetails {
    placeId?: string | null;
    formattedAddress?: string | null;
    addressComponents?: PlacesAddressComponents[] | null;
    geometry?: PlaceGeometry;
    timeZoneName?: string | null;
    timeZoneId?: string | null;
    rawOffset?: number | null;
    parsedAddress?: PlacesParsedAddress | null;
}

export interface PlacesAddressComponents {
    longName?: string | null;
    shortName?: string | null;
    types?: string[] | null;
}

export interface PlaceGeometry {
    location?: GeometryLocation;
}

export interface GeometryLocation {
    lat?: number;
    lng?: number;
}

export interface PlacesParsedAddress {
    street1?: string | null;
    street2?: string | null;
    city?: string | null;
    state?: string | null;
    zipcode?: string | null;
    timeZoneId?: string | null;
    timeZoneName?: string | null;
    rawOffset?: number | null;
}

export interface ZipCoordinates {
    lat?: number;
    long?: number;
}

export interface OutboundContactRequestData {
    profileId?: string | null;
    phone?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    origin?: string | null;
    contactPreference?: string | null;
    force?: boolean;
    time?: string | null;
    timeZone?: string | null;
    notes?: string | null;
}

export interface PharmacySearchResult {
    id?: string;
    npi?: string;
    name?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    phone?: string;
    distance?: number;
    latitude?: number;
    longitude?: number;
    chain?: string;
    chainName?: string;
    isSpecialty?: boolean;
    isMajorChain?: boolean;
    pharmacyServices?: PharmacyServices;
}

export interface PharmacyServices {
    has24hrService?: boolean;
    hasCompounding?: boolean;
    hasDelivery?: boolean;
    hasDriveup?: boolean;
    hasDurableEquipment?: boolean;
    hasEPrescriptions?: boolean;
    hasHandicapAccess?: boolean;
    isHomeInfusion?: boolean;
    isLongTermCare?: boolean;
}

export interface PharmacySearchRequest {
    take?: number;
    skip?: number;
    fields?: string | null;
    zip?: string | null;
    radius?: number;
    pharmacyName?: string | null;
    planPharmacyType?: string;
    latLng?: string | null;
    pharmacyIDType?: number;
}

export interface PlanCheckup {
    id?: string;
    needsConfirmedTimestamp?: Date | null;
    planYear?: number;
    currentPlanId?: string | null;
    currentPlanType?: PlanType | null;
    hasMedSupp?: boolean | null;
    desiredPlanType?: PlanType | null;
    bestPlanId?: string | null;
    loyaltyCarrierKey?: string | null;
    engineId?: string | null;
    type?: string | null;
    engineParams?: { [key: string]: any; } | null;
}

export interface ProfileBase {
    id?: string | null;
    dateOfBirth?: Date | null;
    gender?: Gender | null;
    isTobaccoUser?: boolean | null;
    csnpQualifiers?: CsnpQualifierType[];
    needsAssessment?: NeedsAssessment;
    location?: Location;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    emailAddress?: EmailAddress;
    mobilePhone?: MobilePhone;
    medicareCard?: MedicareCard;
    medicaidInfo?: MedicaidInfo;
    attributions?: Attribution[];
    engineId?: string | null;
}

export interface Profile extends ProfileBase {
    rxs?: Rx[];
    providers?: Provider[];
    pharmacies?: Pharmacy[];
    applications?: Application[];
    consents?: DataConsent[];
    savedPlans?: { [key: string]: string[]; };
    iepContext?: any;
    guaranteedIssueExpiration?: Date | null;
    planCheckups?: PlanCheckup[];
    scheduledCalls?: ScheduledCall[];
    contactPhones?: ContactPhone[];
    ext?: ProfileExt[];
}

export function isProfile(object: any): object is Profile {
    return object && object[''] === 'Profile';
}

export interface Rx {
    identifier?: string | null;
    externalId?: string;
    uuid?: string | null;
    drugName?: string;
    quantity?: number;
    frequency?: number;
    dosage?: RxDosage;
}

export interface RxDosage {
    externalId?: string;
    ndc?: string | null;
    labelName?: string;
    strength?: string;
    form?: string;
    formName?: string;
    isCommonDosage?: boolean | null;
    amountTaken?: number | null;
    every?: number | null;
    package?: RxPackage | null;
}

export interface RxPackage {
    ndc?: string;
    displayText?: string;
    description?: string;
    unitOfMeasure?: string;
    packageSize?: number;
    packageQuantity?: number | null;
    totalPackageQuantity?: number | null;
    commonQuantity?: number | null;
    commonMetricQuantity?: number | null;
    isCommonPackage?: boolean | null;
}

export interface Provider {
    npi?: string;
    externalId?: string;
    uuid?: string | null;
    displayName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    suffix?: string | null;
    title?: string | null;
    specialty?: string | null;
    specialties?: string[];
    rawSpecialties?: string | null;
    isIndividual?: boolean | null;
    type?: string | null;
    totalLocationCount?: number | null;
    locations?: ProviderLocation[];
}

export interface ProviderLocation {
    externalId?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    phoneNumbers?: string[];
}

export interface Pharmacy {
    externalId?: string | null;
    isPreferred?: boolean | null;
    npi?: string | null;
    uuid?: string | null;
    name?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    distance?: number | null;
    latitude?: number | null;
    longitude?: number | null;
    chain?: string | null;
    chainName?: string | null;
    isSpecialty?: boolean | null;
    isMajorChain?: boolean | null;
}

export interface DataConsent {
    profileId?: string;
    partner?: string;
    type?: string;
}

export interface ScheduledCall {
    id?: string;
    startDateTime?: Date;
    source?: string;
    data?: { [key: string]: any; };
}

export interface ProfileExt {
    key?: string;
    valueType?: string | null;
    value?: string | null;
    createdAt?: Date;
}

export enum Gender {
    Male = 1,
    Female = 2,
}

export enum CsnpQualifierType {
    None = 0,
    Diabetes = 1,
    HeartFailure = 2,
    ObstructivePulmonary = 3,
    ChronicKidneyDisease = 4,
    PostRenalOrganTransplantation = 5,
    ChronicLungDisorders = 6,
    ChronicMentalHealth = 7,
    SubstanceUseDisorders = 8,
    Dementia = 9,
    HivAids = 10,
    ObesityOverweightMetabolicSyndrome = 11,
    CardiovascularDisorders = 12,
}

export interface NeedsAssessment {
    eligibleForMedicareBefore2020?: boolean | null;
    hasHighDoctorUtilization?: boolean | null;
    coverageType?: CoverageType | null;
    planType?: PlanType | null;
    costFactor?: CostFactor | null;
    currentPlan?: { [key: string]: string; };
    csnpQualifiers?: CsnpQualifierType[];
    coveragePreferences?: CoveragePreference[];
    additionalBenefits?: AdditionalBenefitType[];
    healthcareUtilization?: HealthcareUtilizationAnswer[];
    coverageGoals?: CoverageGoal[];
    defaultSort?: string | null;
}

export enum CoverageType {
    Healthcare = 1,
    PrescriptionDrug = 2,
    Both = 3,
}

export enum CostFactor {
    ZeroPremium = 1,
    LimitOop = 2,
    LimitCopay = 3,
    LowestEstimatedCosts = 4,
}

export enum CoveragePreference {
    Premium_LowerPremium = 1,
    Premium_LowerCost = 2,
    Network_AnyDoctor = 3,
    Network_Limited = 4,
    Specialist_NoReferral = 5,
    Specialist_RequireReferral = 6,
    Travel_Often = 7,
    Travel_Rarely = 8,
    OopCap_Yes = 9,
    OopCap_No = 10,
    CoverageNonMedicalServices_Yes = 11,
    CoverageNonMedicalServices_No = 12,
}

export enum AdditionalBenefitType {
    None = 0,
    Vision = 1,
    Hearing = 2,
    Dental = 3,
    Fitness = 4,
    Transportation = 5,
    DomesticTravel = 6,
    OtcMedications = 7,
}

export interface HealthcareUtilizationAnswer {
    questionId?: string | null;
    answer?: string | null;
}

export enum CoverageGoal {
    Unknown = 0,
    LowMedicalCost = 1,
    LowDrugCost = 2,
    SeeMyDoctors = 3,
    ExtraCoverage = 4,
    SwitchCarriers = 5,
}

export interface Location {
    zipCode?: string | null;
    fipsCountyCode?: string | null;
    countyName?: string | null;
    stateCode?: string | null;
    stateName?: string | null;
}

export interface EmailAddress {
    address?: string | null;
    isVerified?: boolean;
}

export interface MobilePhone {
    number?: string | null;
    isVerified?: boolean;
}

export interface MedicareCard {
    fullName?: string | null;
    partAEffectiveDate?: Date | null;
    partBEffectiveDate?: Date | null;
    medicareNumber?: string | null;
    isEmpty?: boolean;
}

export interface MedicaidInfo {
    hasMedicaid?: boolean | null;
    medicaidNumber?: string | null;
    validated?: boolean | null;
    isEmpty?: boolean;
}

export interface BoxOfString {
    value?: string | null;
}

export interface Recommendation {
    planType?: PlanType | null;
    recommendationType?: PlanTypeRecommendationType;
    planTypeDisplay?: string | null;
    score?: number;
    factors?: Factor[];
}

export interface PlanTypeRecommendation extends Recommendation {
    coverageType?: string | null;
    otherRecommendations?: Recommendation[];
}

export function isPlanTypeRecommendation(object: any): object is PlanTypeRecommendation {
    return object && object[''] === 'PlanTypeRecommendation';
}

export enum PlanTypeRecommendationType {
    PDP = 1,
    MAPD = 2,
    MS = 3,
    MSA = 4,
    MS_PDP = 5,
    MSA_PDP = 6,
}

export interface Factor {
    iconName?: string | null;
    factorHtml?: string | null;
    explanation?: string | null;
    weights?: { [key: string]: number; };
}

export interface PlanTypeRecommendationRequest {
    profileId?: string;
    availablePlanTypes?: PlanType[];
}

export interface PlanTypeRecommendationConfig {
    coverage_type_override?: CoverageType | null;
    recommendation_priority?: { [key: string]: number; } | null;
    considerations?: { [key: string]: ConsiderationConfig; };
}

export interface ConsiderationConfig {
    decision_override?: boolean | null;
    true?: DecisionConfig;
    false?: DecisionConfig;
}

export interface DecisionConfig {
    factor_display?: string | null;
    icon_name?: string | null;
    healthcare?: FactorWeightConfig | null;
    drug?: FactorWeightConfig | null;
    both?: FactorWeightConfig | null;
}

export interface FactorWeightConfig {
    factor_display_override?: string | null;
    icon_name_override?: string | null;
    weights?: { [key: string]: number; } | null;
}

export interface EligibilityResponse {
    electionPeriod?: string | null;
    sepCode?: string | null;
    coverageStartDate?: Date | null;
}

export interface IepRecommendationResponse {
    iepStart?: Date;
    iepEnd?: Date;
    gepOverride?: boolean | null;
    birthdate?: Date | null;
    recommendation?: IepRecommendation | null;
    attributes?: IepRecommendationAttributes[] | null;
    iepStatus?: IepStatus;
    isGep?: boolean;
}

export enum IepRecommendation {
    Now = 0,
    Iep = 1,
    Gep = 2,
    Within8MonthsOfCoverageEnd = 3,
    Within8MonthsOfStoppingWork = 4,
    Within8MonthsOfActiveDutyRetirement = 5,
}

export enum IepRecommendationAttributes {
    CompanyLessThan20Employees = 0,
    AvoidsPartBPenalties = 1,
}

export enum IepStatus {
    BeforeIep = 0,
    InIep = 1,
    AfterIep = 2,
}

export interface IepRecommendationRequest {
    birthdate?: Date;
    currentCoverage?: IepCurrentCoverageType | null;
    workingForCoverageProvider?: boolean;
    employerMoreThan20Employees?: boolean;
    coverageThroughMarketplace?: boolean;
    workedAtLeast10Years?: boolean;
}

export enum IepCurrentCoverageType {
    EmployerOrSpouse = 0,
    Medicaid = 1,
    VeteransAffairs = 2,
    Champva = 3,
    TricareRetirees = 4,
    TricareActiveDuty = 5,
    Marketplace = 6,
    None = 7,
    PartAOnly = 8,
}

export interface Testimonial {
    id?: string | null;
    profileId?: string | null;
    applicationId?: string | null;
    source?: string;
    responses?: any;
}

export interface ScheduleCallRequest {
    email?: string;
    startDateTime?: Date;
    source?: string;
    data?: { [key: string]: any; };
}

export interface ProviderSearchResult {
    index?: number;
    npi?: string;
    externalId?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    suffix?: string;
    title?: string;
    specialty?: string;
    marketSpecialties?: string[];
    organizationName?: string;
    presentationName?: string;
    isIndividual?: boolean;
    type?: string;
    locations?: ProviderLocationSearchResult[];
}

export interface ProviderLocationSearchResult {
    latitude?: number | null;
    longitude?: number | null;
    id?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    phoneNumbers?: string[];
}

export interface ProviderSearchRequest {
    searchTerm?: string;
    latitude?: number | null;
    longitude?: number | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    radius?: number;
    take?: number | null;
    perPage?: number | null;
    page?: number | null;
    fuzzySort?: boolean;
}

export interface SessionVm {
    data?: any;
    profile?: Profile;
}

export interface Journey {
    id?: number;
    signInPath?: string | null;
    signOutPath?: string | null;
    signUpPath?: string | null;
    accountHomePath?: string | null;
    waypoints?: Waypoint[];
}

export interface Waypoint {
    id?: string;
    path?: string | null;
    component?: string | null;
    type?: WaypointType;
    subType?: WaypointSubType | null;
    layoutOverride?: string | null;
    defaultVersion?: string | null;
    replace?: boolean;
    auth?: WaypointAuth;
    results?: WaypointNav[];
}

export enum WaypointType {
    Page = 1,
    Decision = 2,
    Processing = 3,
    Redirect = 4,
    Splice = 5,
}

export enum WaypointSubType {
    CreateProfile = 0,
    IsNewToMedicare = 1,
    SetDefaultEngineParams = 2,
    RunEngine = 3,
    RunCarrierFootprint = 4,
    SignUpRedirect = 5,
    SignInRedirect = 6,
    QuoteDetailsRedirect = 7,
    IsShoppingForPackage = 8,
    CoveragePrefsTest = 9,
    HasPlanTypeRecommendation = 10,
    ConnectureRedirect = 11,
    SkipPharmacyTest = 12,
    RunPharmacyCampaign = 13,
    ExternalCarrierAppRedirect = 14,
    IsAuthenticated = 15,
    SelectedCoverageType = 16,
    CoverageTypeOrPlanType = 17,
    ShowTobaccoQuestion = 18,
    CanChooseYourOwnAdventure = 19,
    ProhibitImport = 20,
    SkipSpecialistRefTest = 21,
    IsLimitedChoice = 22,
    ShowGenderQuestion = 23,
    ShowBirthdateQuestion = 24,
    IsMsPlanType = 25,
    ShowGettingStarted = 26,
    SetDefaultGoals = 27,
    ShowMedicaidQuestion = 28,
    ShowDefaultSort = 29,
    GetPlanTypeRecommendation = 30,
    LimitedPlanTypeSupply = 31,
    AwaitFootprint = 32,
    IsRxPlanType = 33,
    BrowsePostStandbyVariation = 34,
    ShowIepContext = 35,
    RouteIepResult = 36,
    CompleteIepEdits = 37,
    CancelIepEdits = 38,
    CreateCheckup = 39,
    SetCheckupEngine = 40,
    CurrentPlanKnown = 41,
    CheckupDuringAep = 42,
    SamePlanRecommended = 43,
    CurrentPlanIsPdp = 44,
    NoAccountEnroll = 45,
    IsLocationNeeded = 46,
    IsAep = 47,
    IsPreshop = 48,
    CheckupAepPreRun = 49,
    CheckupPostRun = 50,
    SetPlanTypeMapd = 51,
    SetPlanTypePdp = 52,
    HasPendingDrugsOrDoctors = 53,
    NeedsEngineRun = 54,
    SkipLocationCollection = 55,
    IsSupportHours = 56,
    IsMapdPlanType = 57,
    IsDecember = 58,
    PushToSignUpPostNa = 59,
    WhatBringsYouInEnabled = 60,
    ShowPlanLetterRec = 61,
    CameInForElectionPeriod = 62,
    NeedsOutboundContactInfo = 63,
    GuidedRecEnabled = 64,
    IsMedSuppV2 = 65,
    SetSessionPlanTypeMapd = 66,
    IsAskCsnp = 67,
    IsNewToMedicareEnabled = 68,
    IsPdpUpsellEnabled = 69,
    AskPlanYear = 70,
    ExitFlow = 71,
    SelectedPlanType = 72,
    IsUnlockRecVariant = 73,
    PreApplyPageVersion = 74,
    SetNextPlanYear = 75,
    OtherPlansPushType = 76,
    PushDsnpToCs = 77,
    IsOep = 78,
    IsNewToMedicareStreamlinedEnabled = 79,
    IsMapdAvailable = 80,
    IsPdpUpsellToMapd = 81,
    SpliceDefault = 999,
    SpliceIntro = 1000,
    SpliceAccount = 1001,
    SpliceQuotes = 1002,
    SpliceApply = 1003,
    SpliceNeedsAssessment = 1004,
    SpliceBrowse = 1005,
    SpliceIep = 1006,
    SpliceMs = 1007,
    SpliceCallFirst = 1008,
    SplicePlanCheckup = 1009,
    SpliceYourDrugs = 1010,
    SpliceYourDoctors = 1011,
    SpliceHelpOnly = 1012,
    SplicePlanTypeRec = 1013,
    SpliceMapdHelpOnly = 1014,
    SpliceWhatBringsYouIn = 1015,
    SpliceHelpMeDecide = 1016,
    SpliceOutboundLeads = 1017,
    SpliceGuidedRec = 1018,
    SpliceMedSuppV2 = 1019,
    SplicePdpUpsell = 1020,
    SplicePlanYear = 1021,
    SpliceMapdNoQuotes = 1022,
    SplicePdpShort = 1023,
    SplicePlanTypeSelection = 1024,
    SpliceBookPlanReview = 1025,
}

export enum WaypointAuth {
    Public = 0,
    Protected = 1,
    Guest = 2,
}

export interface WaypointNav {
    result?: WaypointResult;
    nextWaypointId?: string;
}

export enum WaypointResult {
    Next = 0,
    Yes = 1,
    No = 2,
    Journey_Guided = 3,
    Journey_Browse = 4,
    Zip_OneCounty = 5,
    Zip_NCounties = 6,
    CoverageType_Healthcare = 7,
    CoverageType_PrescriptionDrug = 8,
    CoverageType_Both = 9,
    Drugs_None = 10,
    Drugs_NDrugs = 11,
    PlanType_MA = 12,
    PlanType_PDP = 13,
    PlanType_MS = 14,
    PlanType_MSA = 15,
    PlanType_Unsure = 16,
    Browse_Zip = 17,
    Browse_County = 18,
    Browse_Birthdate = 19,
    Browse_Gender = 20,
    Browse_PlanType = 21,
    Browse_Standby = 22,
    GoTo_Import = 23,
    GoTo_Standby = 24,
    GoTo_Apply = 25,
    GoTo_Browse = 26,
    GoTo_SignUp = 27,
    GoTo_SignIn = 28,
    GoTo_Compare = 29,
    GoTo_MsReqData = 30,
    ImportRouter_Acknowledge = 31,
    ImportRouter_Standby = 32,
    ImportRouter_Results = 33,
    CoveragePrefsTest_Compact = 34,
    CoveragePrefsTest_Expanded = 35,
    ApplyRouter_AppSchema = 36,
    ApplyRouter_ConnectureRedirect = 37,
    ApplyRouter_AppSchemaMs = 38,
    ApplyRouter_ConnectureRedirectMs = 39,
    ApplyRouter_CarrierRedirectMs = 40,
    AddNeeds_Birthdate = 41,
    AddNeeds_Gender = 42,
    AddNeeds_Import = 43,
    CoverageTypeOrPlanType_Coverage = 44,
    CoverageTypeOrPlanType_Plan = 45,
    PlanTypeRec_PDP = 46,
    PlanTypeRec_MAPD = 47,
    PlanTypeRec_MS = 48,
    PlanTypeRec_MSA = 49,
    PlanTypeRec_MS_PDP = 50,
    PlanTypeRec_MSA_PDP = 51,
    GoalsRouter_CostFactors = 52,
    GoalsRouter_Drugs = 53,
    GoalsRouter_Doctors = 54,
    GoalsRouter_ExtraCoverage = 55,
    GoalsRouter_Carriers = 56,
    GoalsRouter_Done = 57,
    CostFactors_LowestEst = 58,
    CostFactors_Other = 59,
    DefaultSort_HealthpilotRec = 60,
    DefaultSort_Other = 61,
    PostStandby_Quotes = 62,
    PostStandby_LimitedChoice = 63,
    PostStandby_PlanFinder = 64,
    Iep_HelpSigningUp = 65,
    Iep_FindingAPlan = 66,
    Iep_CurrentlyMedicaid = 67,
    Iep_CurrentlyVa = 68,
    Iep_CurrentlyOther = 69,
    Iep_CurrentlyNone = 70,
    Iep_CurrentlyPartA = 71,
    Iep_CreateAccount = 72,
    Iep_CancelEditing = 73,
    Iep_EditsComplete = 74,
    Iep_ShowRecommendation = 75,
    IepDashboard_GuidedFlow = 76,
    IepDashboard_EditAnswers = 77,
    MsT_BrowsePdp = 78,
    Iep_BrowsePlans = 79,
    CallFirst_Zip = 80,
    CallFirst_PlanType = 81,
    CallFirst_Review = 82,
    CallFirst_Standby = 83,
    CallFirst_ContactAgent = 84,
    Checkup_CurrentPlan_CarrierFound = 85,
    Checkup_CurrentPlan_CarrierNotFound = 86,
    Checkup_CurrentPlan_PlanFound = 87,
    Checkup_CurrentPlan_PlanNotFound = 88,
    Checkup_CurrentPlan_Skip = 89,
    Checkup_Complete_ViewAllPlans = 90,
    Checkup_Complete_CompareTopTwo = 91,
    Checkup_Complete_ToDashboard = 92,
    Checkup_Dashboard_ConfirmNeeds = 93,
    Checkup_Dashboard_CompareRecToCurrent = 94,
    Checkup_Dashboard_SeeRecommendation = 95,
    Wbyi_Oep = 96,
    Wbyi_NewToMedicare = 97,
    Wbyi_Moving = 98,
    Wbyi_Other = 99,
    Wbyi_CoverageLost = 100,
    GetHelp_Human = 101,
    GetHelp_Online = 102,
    SoftSignUp_Success = 103,
    SoftSignUp_AccountExists = 104,
    NextStep_PlanDetails = 105,
    NextStep_ScheduleCall = 106,
    NextStep_ExplorePlans = 107,
    ExploreOptions_CompareTop3 = 108,
    ExploreOptions_LowerCost = 109,
    ExploreOptions_DoctorCoverage = 110,
    ExploreOptions_JustBrowse = 111,
    ExploreOptions_Other = 112,
    MedSupp_Plans = 113,
    MedSupp_Details = 114,
    GoTo_MedSupp = 115,
    Status_NewToMe = 116,
    Status_LetsGo = 117,
    Status_Help = 118,
    Status_KnowCoverage = 119,
    Basics_NoMedicare = 120,
    Paths_PlanType = 121,
    GetStarted_Agent = 122,
    GetStarted_PlanType = 123,
    PlanYear_Current = 124,
    PlanYear_Next = 125,
    PreApply_PushToCs = 126,
    PreApply_MedicareCard = 127,
    GoTo_MapdQuoteGate = 128,
    OtherPlansPushType_Call = 129,
    OtherPlansPushType_Chat = 130,
    PreApply_DsnpAppGate = 131,
    TwoPaths_MA = 132,
    TwoPaths_MS = 133,
    TwoPaths_NotSure = 134,
    MapdAvailable = 135,
    MapdUnavailable = 136,
}

export interface BootstrapFlagState {
    state?: any;
}

export interface EnrollRequest {
    engineParams?: EngineParams;
    profileId?: string;
    applicationId?: string;
    planId?: string;
    title?: string | null;
    firstName?: string;
    lastName?: string;
    middleInitial?: string | null;
    city?: string | null;
    state?: string | null;
    address1?: string | null;
    address2?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    mbi?: string | null;
    enroller?: EnrollRequestEnroller | null;
}

export interface EngineParams {
    planYear?: number;
    zip?: string;
    county?: string;
    countyName?: string;
    state?: string;
    currentPlanId?: string | null;
    startMonth?: number;
    startYear?: number;
    dateOfBirth?: Date;
    gender?: string;
    partAEffectiveDate?: Date | null;
    partBEffectiveDate?: Date | null;
    isTobaccoUser?: boolean | null;
    rxs?: EngineRx[];
    doctors?: EngineDoctor[];
    pharmacy?: EnginePharmacy | null;
    additionalBenefits?: PlanBenefitType[];
    surveyAnswers?: EngineSurveyAnswer[];
    remoteConfigKey?: string | null;
    planTypes?: PlanType[];
    userType?: RequestUserType;
    snpTypes?: SnpType[];
    csnpQualifiers?: CsnpQualifierType[];
    overrides?: string[];
}

export interface EngineRx {
    frequency?: number;
    ndc?: string;
    uuid?: string | null;
    qty?: number;
    metricQty?: number;
    name?: string | null;
    pkg?: EngineRxPkg | null;
}

export interface EngineRxPkg {
    ndc?: string;
}

export interface EngineDoctor {
    npi?: string;
    externalId?: string;
    uuid?: string | null;
    locationExternalId?: string;
    name?: string | null;
    specialty?: string | null;
}

export interface EnginePharmacy {
    npi?: string;
    uuid?: string | null;
    name?: string | null;
    isMailOrder?: boolean;
}

export enum PlanBenefitType {
    Vision = 1,
    Hearing = 2,
    Dental = 3,
    FitnessBenefits = 4,
    Transportation = 5,
    DomesticTravel = 6,
    OverTheCounterMedications = 7,
}

export interface EngineSurveyAnswer {
    questionId?: string;
    answer?: string;
}

export enum RequestUserType {
    Customer = 0,
    Agent = 1,
}

export interface EnrollRequestEnroller {
    agentFirstName?: string | null;
    agentLastName?: string | null;
    agentNPN?: string | null;
    brokerId?: string | null;
    userType?: string | null;
}

export interface CarrierFootprint {
    userType?: RequestUserType;
    carrierKey?: string;
    carrierName?: string;
    carrierId?: string;
    planTypes?: PlanTypeCount[];
    logos?: string[];
    disclosures?: string[];
}

export interface PlanTypeCount {
    type?: PlanType;
    filterKeys?: string[];
    count?: number;
    planLetters?: PlanLetter[];
}

export interface PlanLetter {
    type?: string;
    annualRates?: PlanLetterRate;
    monthlyRates?: PlanLetterRate;
}

export interface PlanLetterRate {
    lowest?: number;
    highest?: number;
}

export interface PlanSearchRequest {
    zip?: string;
    county?: string;
    year?: number;
    effectiveDate?: Date | null;
    types?: PlanType[];
    state?: string;
    snpTypes?: SnpType[];
}

export interface CarrierFootprintRequest extends PlanSearchRequest {
    remoteConfigKey?: string | null;
    csnpQualifiers?: CsnpQualifierType[];
}

export function isCarrierFootprintRequest(object: any): object is CarrierFootprintRequest {
    return object && object[''] === 'CarrierFootprintRequest';
}

export interface MedigapFootprintResponse {
    data?: MedigapFootprint[];
}

export interface MedigapFootprint {
    carrierId?: string;
    carrierName?: string;
    carrierKey?: string;
    filterKeys?: string[];
    plans?: MedigapFootprintPlan[];
}

export interface MedigapFootprintPlan {
    type?: string;
    annualRates?: MedigapFootprintRates;
    monthlyRates?: MedigapFootprintRates;
}

export interface MedigapFootprintRates {
    lowest?: number;
    highest?: number;
}

export interface MedigapFootprintParams {
    zipCode?: string;
    effectiveDate?: Date;
    gender?: string | null;
    age?: number | null;
    isTobaccoUser?: boolean | null;
}

export interface EngineSnapshot {
    id?: string;
    params?: EngineParams;
    quotes?: PlanQuote[];
    plans?: PlanDetail[];
    connectureSessionId?: string | null;
}

export interface PlanQuote {
    medicareId?: string;
    externalId?: string;
    type?: PlanType;
    snpType?: SnpType;
    name?: string;
    planLetter?: string | null;
    isCurrentPlan?: boolean;
    recommendation?: PlanRecommendation | null;
    drugCoverage?: DrugCoverage | null;
    providerCoverage?: ProviderCoverage | null;
    pharmacyCoverage?: PharmacyCoverage | null;
    additionalBenefits?: AdditionalBenefit[];
    planAttributes?: string[];
    summary?: string | null;
    benchmarks?: PlanBenchmarks | null;
}

export interface PlanRecommendation {
    medicareId?: string;
    score?: Score | null;
    costs?: Costs | null;
    planType?: PlanType;
    debug?: { [key: string]: number; };
}

export interface Score {
    mail?: ScoreDetail | null;
    retail?: ScoreDetail | null;
}

export interface ScoreDetail {
    tier?: string | null;
    picwellScore?: number | null;
    dimensions?: ScoreDimensions | null;
}

export interface ScoreDimensions {
    realCost?: number | null;
    riskProtection?: number | null;
    healthProviderLocations?: number | null;
    medicareStarRatings?: number | null;
}

export interface Costs {
    full?: CostDetail;
    partial?: CostDetail;
}

export interface CostDetail {
    services?: ServiceCosts;
    drugs?: DrugCosts;
    realCost?: RealCost;
    partB?: PartBCosts;
    monthlyPremium?: number;
}

export interface ServiceCosts {
    inNetwork?: ServiceCostDetail;
    outNetwork?: ServiceCostDetail;
}

export interface ServiceCostDetail {
    deciles?: number[];
    mean?: number;
}

export interface DrugCosts {
    mail?: DrugCostDetail;
    retail?: DrugCostDetail;
}

export interface DrugCostDetail {
    uncovered?: number;
    covered?: number;
    total?: number;
}

export interface RealCost {
    deciles?: number[];
    mean?: number;
}

export interface PartBCosts {
    monthlyPremium?: number;
    monthlyPremiumReduction?: number;
}

export interface DrugCoverage {
    retailCost?: number | null;
    mailCost?: number | null;
    pharmacyCosts?: PharmacyCost[];
    coverageSummaries?: DrugCoverageSummary[];
}

export interface PharmacyCost {
    pharmacyExternalId?: string | null;
    monthlyCosts?: MonthlyDrugCost[];
    drugCosts?: PharmacyDrugCost[];
}

export interface MonthlyDrugCost {
    monthNumber?: number;
    monthName?: string;
    details?: MonthlyDrugCostDetail[];
}

export interface MonthlyDrugCostDetail {
    fullCost?: number;
    memberCost?: number;
    phase?: string;
    externalId?: string;
}

export interface PharmacyDrugCost {
    drugName?: string;
    qty?: number;
    fullCost?: number | null;
    deductibleCopay?: number | null;
    initialCopay?: number | null;
    catastrophicCopay?: number | null;
    externalId?: string;
}

export interface DrugCoverageSummary {
    drugName?: string | null;
    externalId?: string | null;
    ndc?: string | null;
    uuid?: string | null;
    tier?: number | null;
    tierName?: string | null;
    quantityLimits?: string | null;
    stepTherapy?: boolean;
    priorAuthorization?: boolean;
    isCovered?: boolean;
}

export interface ProviderCoverage {
    providers?: ProviderCoverageDetail[];
}

export interface ProviderCoverageDetail {
    npi?: string | null;
    uuid?: string | null;
    inNetwork?: boolean;
    externalId?: string;
    name?: string | null;
    specialty?: string | null;
    isPcpEligible?: boolean;
    carrierProviderId?: string | null;
}

export interface PharmacyCoverage {
    pharmacies?: PharmacyCoverageDetail[];
}

export interface PharmacyCoverageDetail {
    npi?: string;
    uuid?: string | null;
    externalId?: string;
    pharmacyType?: PharmacyType | null;
    isPreferred?: boolean;
    inNetwork?: boolean;
    name?: string | null;
}

export enum PharmacyType {
    Retail = 1,
    Mail = 2,
}

export interface AdditionalBenefit {
    sortKey?: number;
    name?: string;
    covered?: boolean;
}

export interface PlanBenchmarks {
    monthlyPremium?: Benchmark | null;
    doctorsInNetwork?: Benchmark | null;
    drugCosts?: Benchmark | null;
    healthcareCosts?: Benchmark | null;
}

export interface Benchmark {
    tag?: string;
    tone?: BenchmarkTone;
    data?: BenchmarkData;
}

export enum BenchmarkTone {
    Standout = "standout",
    Context = "context",
    Gap = "gap",
    Prompt = "prompt",
}

export interface BenchmarkData {
    planCount?: number | null;
    totalPlans?: number | null;
    doctorCount?: number | null;
}

export interface PlanDetail {
    externalId?: string;
    medicareId?: string;
    name?: string;
    year?: number | null;
    type?: PlanType;
    policyType?: PolicyType;
    isSnp?: boolean;
    snpType?: SnpType;
    snpDescription?: string;
    carrierKey?: string | null;
    carrierId?: string | null;
    carrierName?: string | null;
    externalCarrierName?: string;
    brandId?: string | null;
    brandName?: string | null;
    naic?: string | null;
    appFlow?: ApplicationFlow | null;
    appDestination?: ApplicationDestination | null;
    externalAppUrl?: string | null;
    logoKey?: string | null;
    disclosuresKey?: string | null;
    carrierFilterKey?: string | null;
    premium?: number | null;
    selectedBenefits?: { [key in keyof typeof PlanBenefitType]?: boolean; };
    medicalPremium?: number | null;
    drugPremium?: number | null;
    medicalDeductible?: number | null;
    drugDeductible?: number | null;
    combinedDeductible?: number | null;
    maxOutOfPocket?: number | null;
    combinedMaxOutOfPocket?: number | null;
    starRating?: number | null;
    isSelect?: boolean | null;
    planLetter?: string | null;
    msType?: string | null;
    providerBenefits?: ProviderBenefits | null;
    riders?: Rider[];
    coinsurance?: number | null;
    initialCoverageLimit?: number | null;
    catastrophicLimit?: number | null;
    formulary?: Formulary | null;
    hasDrugCoverage?: boolean | null;
    hearingBenefits?: CoveredBenefits | null;
    visionBenefits?: CoveredBenefits | null;
    dentalBenefits?: CoveredBenefits | null;
    otcDrugBenefits?: CoveredBenefits | null;
    curatedBenefits?: PlanBenefitSection[];
    externalResources?: ExternalResources | null;
    isNonCommissioned?: boolean;
    isNonLicensed?: boolean;
    ext?: PlanExt | null;
    householdDiscount?: number | null;
    householdDiscountType?: string | null;
    policyFee?: number | null;
    rateType?: string | null;
    yearsInMarket?: string | null;
    rates?: MedigapPlanRate[][];
    csnpQualifiers?: CsnpQualifierType[] | null;
    collectSsbci?: boolean;
    ssbciPrograms?: string[] | null;
}

export interface ProviderBenefits {
    doctorCopay?: BenefitAmount | null;
    specialistCopay?: BenefitAmount | null;
}

export interface BenefitAmount {
    amount?: number | null;
    amountType?: PlanBenefitCostType | null;
}

export enum PlanBenefitCostType {
    Copay = 1,
    Coinsurance = 2,
}

export interface Rider {
    externalId?: string;
    planName?: string | null;
    planSubType?: string | null;
    planTypeDescription?: string | null;
    applicationFee?: number | null;
    medicalPremium?: number | null;
    calculatedMedicalPremium?: number | null;
    hasCalculatedMedicalPremium?: boolean | null;
}

export interface Formulary {
    tiers?: FormularyTier[];
}

export interface FormularyTier {
    tierName?: string;
    tierNumber?: number;
    tierDesc?: string;
    isExceptionTier?: boolean;
    thirtyDayPricing?: FormularyTierPricing;
    sixtyDayPricing?: FormularyTierPricing;
    ninetyDayPricing?: FormularyTierPricing;
}

export interface FormularyTierPricing {
    preferredRetail?: BenefitAmount | null;
    preferredMail?: BenefitAmount | null;
    standardRetail?: BenefitAmount | null;
    standardMail?: BenefitAmount | null;
}

export interface CoveredBenefits {
    benefits?: PlanBenefit[];
    maxBenefit?: number | null;
    isCovered?: boolean;
}

export interface BenefitExplanation {
    name?: string | null;
    description?: string | null;
    networkType?: NetworkType | null;
}

export interface PlanBenefit extends BenefitExplanation {
    categoryId?: BenefitCategory;
    details?: PlanBenefitDetail[] | null;
}

export function isPlanBenefit(object: any): object is PlanBenefit {
    return object && object[''] === 'PlanBenefit';
}

export enum BenefitCategory {
    Custom = 0,
    InpatientHospitalCare = 4,
    InpatientMentalHealthCare = 5,
    SkilledNursingFacility = 6,
    HomeHealthCare = 7,
    DoctorVisits = 9,
    ChiropracticServices = 10,
    PodiatryServices = 11,
    OutpatientMentalHealthCare = 12,
    OutpatientSubstanceAbuse = 13,
    OutpatientsServicesAndSurgery = 14,
    Ambulance = 15,
    EmergencyCare = 16,
    UrgentCare = 17,
    DurableMedicalEquipment = 19,
    ProstheticDevices = 20,
    DiabetesSuppliesAndServices = 21,
    DiagnosticTestsLabsRadiologyAndXrays = 22,
    KidneyDiseaseEducation = 29,
    DentalServices = 31,
    HearingServices = 32,
    VisionServices = 33,
    AnnualPhysicalExam = 34,
    PreventiveServices = 35,
    Transportation = 36,
    Acupuncture = 37,
    SpecialistVisit = 40,
    AmbulatorySurgeryCenter = 41,
    OccupationalTherapyVisits = 43,
    PhysicalAndOrSpeechTherapyVisits = 44,
    CardiacRehabServices = 45,
    MedicareCoveredDiagnosticRadiologyNoXrays = 46,
    MedicareCoveredTherapeuticRadiologyServices = 47,
    MedicareCoveredLabServices = 48,
    MedicareCoveredXrays = 49,
    RenalDialysis = 54,
    OverTheCounterItems = 55,
    ContactLenses = 150,
    FitnessBenefit = 319,
    AirAmbulance = 321,
    GlaucomaScreening = 322,
    DiabetesSelfManagementServices = 323,
    DiabeticShoesOrInserts = 324,
    MedicareCoveredMedicalSupplies = 325,
    AdditionalTelehealth = 333,
    OpioidTreatment = 334,
    PersonalEmergencyResponseSystem = 372,
    MealBenefit = 375,
    DentalDiagnosticServices = 377,
    OralExams = 378,
    EyeglassesLensesAndFrames = 379,
    MedicareCoveredEyewear = 380,
    HearingAidsAllTypes = 381,
    RoutineHearingExams = 382,
    PsychiatricServices = 383,
    ChemotherapyAndRadiation = 384,
    PartBGiveback = 388,
    DentalCleaning = 391,
    DentalXrays = 392,
    DentalFluorideTreatment = 393,
    DentalRestorativeServices = 395,
    DentalEndodontics = 396,
    DentalPeriodontics = 397,
    DentalExtractions = 398,
    DentalProsthodontics = 399,
    EyeglassFrames = 402,
    EyeglassLenses = 403,
    RoutineEyeExams = 404,
    EyewearUpgrades = 515,
    HearingAidFittingEval = 517,
    PulmonaryRehabilitationServices = 518,
    WorldwideEmergencyCoverage = 523,
    WorldwideUrgentCare = 525,
    FlexCard = 1542,
    MedicaidEligibility = 1550,
    NursingHomeServices = 1562,
    MedicareCoveredZeroDollarPreventiveServices = 1570,
    IntensiveCardiacRehabilitationServices = 1580,
    GroupSessions = 1605,
    OutpatientDiagnosticTherapeuticRadiologicalServices = 1607,
    EkgAfterWelcomeToMedicare = 1650,
    PartBInsulinDrugs = 1683,
}

export interface PlanBenefitDetail extends BenefitAmount {
    rangeStart?: number | null;
    rangeEnd?: number | null;
}

export function isPlanBenefitDetail(object: any): object is PlanBenefitDetail {
    return object && object[''] === 'PlanBenefitDetail';
}

export enum NetworkType {
    InNetwork = 1,
    OutOfNetwork = 2,
}

export interface PlanBenefitSection {
    sectionId?: BenefitSection;
    desc?: string;
    benefits?: PlanBenefit[];
}

export enum BenefitSection {
    CostEssentials = 1,
    RegularAndPreventive = 2,
    Emergency = 3,
    MentalHealth = 4,
    Diagnostic = 5,
    EquipmentAndDiabetic = 6,
    Dental = 7,
    Hearing = 8,
    Vision = 9,
    MoreBenefits = 10,
    Therapy = 11,
    DrugsAndPharmacy = 12,
}

export interface ExternalResources {
    enrollmentFormUrl?: string | null;
    evidenceOfCoverageUrl?: string | null;
    starRatingsUrl?: string | null;
    summaryOfBenefitsUrl?: string | null;
    outlineOfCoverageUrl?: string | null;
    buyingGuideUrl?: string | null;
}

export interface PlanExt {
    yearsInMarket?: number | null;
    policyFee?: number | null;
    variations?: MsVariation[];
}

export interface MsVariation {
    ratingClass?: string | null;
    rateType?: string | null;
    discountCategory?: string | null;
    rate?: MsRate;
    discounts?: MsDiscount[] | null;
    ageIncreases?: number[] | null;
}

export interface MsRate {
    annual?: number | null;
    quarter?: number | null;
    month?: number | null;
    semiAnnual?: number | null;
}

export interface MsDiscount {
    name?: string | null;
    rule?: string | null;
    type?: string | null;
    value?: number | null;
}

export interface MedigapPlanRate {
    monthlyRate?: number;
    quarterlyRate?: number;
    semiAnnualRate?: number;
    annualRate?: number;
    ratingClass?: string;
    discountCategory?: string;
    medigapCounty?: string;
    discountedRates?: MedigapPlanRate[] | null;
}

export interface RunEngineRequest {
    id?: string | null;
    profileId?: string | null;
    params?: EngineParams;
}

export interface EnrollResponse {
    url?: string;
    parameters?: string | null;
    message?: string | null;
    enrollActionType?: number | null;
    internalPlanID?: number | null;
    formID?: string;
    method?: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

async function processResponse<T>(response: Response): Promise<T> {
    const status = response.status;
    let _headers: any = {}; 
    if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 200) {
        return response._data as T;
    } else if (status !== 200 && status !== 204) {
        return throwException("An unexpected server error occurred.", status, JSON.stringify(response._data), _headers, response._data);
    }
    return Promise.resolve<T>(null as any);
}